import Icon from "../../components/Icon";
import ImageWrapper from "../../components/ImageWrapper";
import Button from "../../components/Button";
import smile from "../../assets/img/smile1.jpg";
import shini from "../../assets/img/edm-1.jpg";
import collageEdm from "../../assets/img/collage-edm.png";
import faceti from "../../assets/img/faceti.jpg";
import bonding from "../../assets/img/bonding.jpg";
import koronki from "../../assets/img/koronki.jpg";
import ContactForm from "../../sections/ContactForm";

const services = [
  {
    title: "Фасети",
    src: faceti,
    description:
      "Фасетите са тънки полупрозрачни керамични люспи, които се закрепват само върху предната повърхност на зъбите. Те успешно коригират цвета, формата и големината на зъбите, без да променят цвета си с времето, което ги прави предпочитан метод за постигане на перфектната усмивка.",
  },
  {
    title: "Бондинг",
    src: bonding,
    description:
      "Бондингът представлява дентална процедура, при която фотополимерен материал се поставя директно върху зъба. Той коригира несъвършенства като отчупвания, пукнатини, разстояния и износени ръбове. Процедурата дава видим резултат само в рамките на едно посещение, но изисква поддръжка през няколко години.",
  },
  {
    title: "Циркониеви Коронки и Мостове",
    src: koronki,
    description:
      "Циркониевите коронки и мостове са най-високо технологичните конструкции в денталната медицина. Те се използват за мостове с един или повече липсващи зъби и са предпочитани заради здравината и биотолерантността си.",
  },
];

function EDM() {
  return (
    <>
      <div className="bg-pop w-full h-[80vh] bg-cover bg-center flex items-center justify-center">
        <h1 className="text-4xl w-5/6 lg:text-5xl text-white text-center font-extrabold">
          Естетична Дентална Медицина
        </h1>
      </div>
      <div className="page__width my-32 gap-2 flex flex-col items-center justify-center">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-center text-heading">
          Пътят към Красива Усмивка
        </h2>
        <p className="text-body text-lg text-center">
          Постигането на здрава и естетична усмивка изисква прецизен анализ на
          зъбите, венците, захапката и лицето. В зависимост от индивидуалните
          нужди на пациента се прилагат разнообразни методи за корекция и
          подобрение, за да се създаде перфектен баланс между функционалност и
          естетика.
        </p>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={shini} className="w-full rounded-lg aspect-square" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Грижа за Здрави Зъби Преди Естетично Лечение
          </h2>
          <p className="text-base text-body font-normal">
            Преди всяка естетична процедура, всички зъби преминават през
            профилактика – лечение на кариеси, коренови терапии и пародонтално
            лечение при необходимост. Това осигурява здрава основа за постигане
            на дълготраен и красив резултат.
          </p>
          <div className="flex flex-col gap-4 mb-2">
            <div className="flex gap-4 items-center">
              <div className="p-4 bg-white shadow-icon rounded-md flex items-center justify-center">
                <Icon name="surgery" className="w-7 h-7 text-brand" />
              </div>
              <h3 className="text-2xl font-bold text-heading">
                Хирургични Интервенции
              </h3>
            </div>
            <div className="flex flex-col mb-2">
              <p className="text-base text-body font-normal">
                Нашата клиника предлага широка гама хирургични услуги – от
                екстракции на зъби и корени до поставяне на зъбни импланти и
                лечение на възпалителни абсцеси.
              </p>
            </div>
          </div>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row-reverse items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={smile} className="w-full rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          {/* <h2 className="text-3xl font-extrabold text-heading">
            Ролята на Мини Имплантите в Ортодонтията
          </h2> */}
          <p className="text-base text-body font-normal">
            Първоначалният преглед включва оценка на усмивката и обсъждане на
            подходящите опции за лечение – от ортодонтско подреждане до
            протетични възстановявания с фасети или корони.
          </p>
          <p className="text-base text-body font-normal">
            Събирането на данни чрез снимки, сканиране и рентгенови изследвания
            дава основа за дигитално проектиране на новата усмивка. Пациентите
            могат предварително да видят резултата чрез временни конструкции
            преди финалното поставяне на фасети или корони.
          </p>

          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>
      <div className="page__width mt-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="text-center flex flex-col items-center rounded-lg p-6"
            >
              <ImageWrapper
                src={service.src}
                alt={service.title}
                className="rounded-full mb-4 w-full"
              />
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="page__width mt-20 flex flex-col justify-center items-center">
        <h2 className="text-3xl font-extrabold text-heading my-8">Преди и След</h2>
        <ImageWrapper src={collageEdm} className="w-full lg:w-2/3 rounded-xl" />
      </div>

      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="#">Свържи се с нас</Button>
      </div>
    </>
  );
}

export default EDM;
